/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DayOfWeek } from './DayOfWeek';
import {
    DayOfWeekFromJSON,
    DayOfWeekFromJSONTyped,
    DayOfWeekToJSON,
    DayOfWeekToJSONTyped,
} from './DayOfWeek';

/**
 * 
 * @export
 * @interface ClassDayRequest
 */
export interface ClassDayRequest {
    /**
     * 
     * @type {DayOfWeek}
     * @memberof ClassDayRequest
     */
    day: DayOfWeek;
    /**
     * 
     * @type {string}
     * @memberof ClassDayRequest
     */
    startTime: string;
    /**
     * 
     * @type {string}
     * @memberof ClassDayRequest
     */
    endTime: string;
}



/**
 * Check if a given object implements the ClassDayRequest interface.
 */
export function instanceOfClassDayRequest(value: object): value is ClassDayRequest {
    if (!('day' in value) || value['day'] === undefined) return false;
    if (!('startTime' in value) || value['startTime'] === undefined) return false;
    if (!('endTime' in value) || value['endTime'] === undefined) return false;
    return true;
}

export function ClassDayRequestFromJSON(json: any): ClassDayRequest {
    return ClassDayRequestFromJSONTyped(json, false);
}

export function ClassDayRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClassDayRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'day': DayOfWeekFromJSON(json['day']),
        'startTime': json['startTime'],
        'endTime': json['endTime'],
    };
}

export function ClassDayRequestToJSON(json: any): ClassDayRequest {
    return ClassDayRequestToJSONTyped(json, false);
}

export function ClassDayRequestToJSONTyped(value?: ClassDayRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'day': DayOfWeekToJSON(value['day']),
        'startTime': value['startTime'],
        'endTime': value['endTime'],
    };
}

